/** Tokens from chaavi_vendor_chat.html (aligned with vendor dashboard CHA) */
export const VCH = {
  cream: '#f5f2ec',
  ink: '#3a2e1e',
  muted: '#a89880',
  dateMuted: '#c0b8a8',
  barMuted: '#7a6a55',
  border: '#e8e0d4',
  rule: '#f5f0e8',
  panelHeadRule: '#f0ebe0',
  accent: '#c0873a',
  accentHover: '#a87030',
  convActiveBg: '#fdf6ed',
  convHoverBg: '#fdfaf5',
  chatAreaBg: '#fdfaf5',
  noticeBg: '#fef4e0',
  noticeBorder: '#e8c870',
  noticeInk: '#806020',
  bubbleOut: '#c0873a',
  bubbleInBg: '#fff',
  online: '#4a9e6a',
  dotUnread: '#c0873a',
} as const;
